module.exports = __webpack_public_path__ + "img/web_logo.c79b3de2.png";